module.exports = function () {
    // Check if page is "shop"
    const shop = document.querySelector('.shop-container');

    if (!shop) {
        return;
    }

    // Get list items
    const sidebar = shop.querySelectorAll('.filter-products__items');


    if (sidebar) {
        sidebar.forEach((sidebarItem) => {
            sidebarItem.addEventListener('click', (e) => {
                const productsContainer = shop.querySelector('.blocAjaxShop');
                const valueItemSelected = e.target.id;

                const productsContainerGlobal = shop.querySelector('.products-container');
                productsContainerGlobal.dataset.category = valueItemSelected;
                // Ajax Request
                const xhr = new XMLHttpRequest();
                xhr.open('POST', ajaxurl, true);
                xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                var params = 'action=sidebarReload&categorie=' + valueItemSelected;
                xhr.send(params);
              
                xhr.onreadystatechange = () => {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        if(xhr.response) {
                            // clean bloc before ajax
                            productsContainer.innerHTML ="";
                            
                            // Add new html
                            productsContainer.innerHTML = xhr.response;

                            checkButtonMoreProducts();

                            const quantityDiv = document.querySelectorAll('div.quantity');
                        
                            quantityDiv.forEach((element) => {
                                const quantityNav = element.querySelector('.quantity-nav');
                                
                                if (quantityNav === null) {
                                    const htmlDiv = '<div class="quantity-nav"><div class="quantity-button quantity-down">-</div><div class="quantity-button quantity-up">+</div></div>';
                                    console.log('htmlDiv', htmlDiv);
                                    element.insertAdjacentHTML("beforeend", htmlDiv);
                                    orderGestion(element);
                                }
                            });

                            jQuery.getScript("/resources/p/woocommerce/assets/js/frontend/add-to-cart-variation.min.js");                                
                            jQuery('.variations_form').each(function () {
                                jQuery(this).wc_variation_form();
                            });
                        }
                    }
                }
            });
        });
    }

    // Button more products

    const moreProductsButton = shop.querySelector('.moreProducts')
    
    // check if button is visible
    checkButtonMoreProducts();

    if (moreProductsButton) {
        moreProductsButton.addEventListener('click', () => {
            // const blocAjaxShop = shop.querySelector('.blocAjaxShop');
            const productsContainer = shop.querySelector('.products-container');
            const blocNav = productsContainer.querySelector('.products');
            const page = parseInt(productsContainer.dataset.paged);
            const categorie = productsContainer.dataset.category;

            // Ajax Request
            const xhr = new XMLHttpRequest();
            xhr.open('POST', ajaxurl, true);
            xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            var params = 'action=addMoreProduct&categorie=' + categorie + '&page=' + page;
            
            xhr.send(params);
        
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    if(xhr.response) {
                        blocNav.insertAdjacentHTML('beforeend', xhr.response);
                        productsContainer.dataset.paged = parseInt(page) + 1;

                        checkButtonMoreProducts();

                        const quantityDiv = document.querySelectorAll('div.quantity');
                        
                        quantityDiv.forEach((element) => {
                            const quantityNav = element.querySelector('.quantity-nav');
                            
                            if (quantityNav === null) {
                                const htmlDiv = '<div class="quantity-nav"><div class="quantity-button quantity-down">-</div><div class="quantity-button quantity-up">+</div></div>';
                                console.log('htmlDiv', htmlDiv);
                                element.insertAdjacentHTML("beforeend", htmlDiv);
                                orderGestion(element);
                            }
                        });
                        
                        /*
                            Apply hover animation on product in category page
                            L'animatin passe par du js pour ne pas avoir l'animation s'il n'y a pas d'image hover
                        */
                        const productWrap = document.querySelectorAll('.woocommerce-loop-product__link');

                        productWrap.forEach((item) => {
                            const imageHover = item.querySelector('.image-product__hover');
                            if (imageHover) {
                                item.addEventListener('mouseenter', () => {
                                    item.classList.add('js-is-hover');
                                });
                                item.addEventListener('mouseleave', () => {
                                    item.classList.remove('js-is-hover');
                                });
                            }
                        });

                        jQuery.getScript("/resources/p/woocommerce/assets/js/frontend/add-to-cart-variation.min.js");    
                        jQuery('.variations_form').each(function () {
                            jQuery(this).wc_variation_form();
                        });
                    }
                }
            }
        });
    }
};


function checkButtonMoreProducts()
{
    const shop = document.querySelector('.shop-container');
    const moreProductsButton = shop.querySelector('.moreProducts')
    const productsContainer = shop.querySelector('.products-container');
    const page = parseInt(productsContainer.dataset.paged);
    const totalPage = parseInt(productsContainer.dataset.totalPage);

    if (totalPage <= page ) {
        moreProductsButton.style.display = "none";
    } else {
        moreProductsButton.style.display = "flex";
    }
}

function orderGestion(element)
{
    const input = element.querySelector('input[type="number"]');
    const btnUp = element.querySelector('.quantity-up');
    const btnDown = element.querySelector('.quantity-down');
    let max = input.max;

    if(max == null) {
        max = 0;
    } else {
        max = input.max;
    }

    btnUp.addEventListener('click', () => {
        const max = input.max;
        const oldValue = parseFloat(input.value);
        let newVal;
        
        if (oldValue >= max && max > 0) {
            newVal = oldValue;

        } else {
            newVal = oldValue + 1;
        }

        const inputBloc = element.querySelector('input');
        inputBloc.value = newVal;
    })

    btnDown.addEventListener('click', () => {
        const min = input.min;
        const oldValue = parseFloat(input.value);
        let newVal;
        
        if (oldValue <= min) {
            newVal = oldValue;
        } else {
            newVal = oldValue - 1;
        }

        const inputBloc = element.querySelector('input');
        inputBloc.value = newVal;
    })
}
